import { render, staticRenderFns } from "./GuideSidebar.vue?vue&type=template&id=66110c78&lang=pug&"
import script from "./GuideSidebar.vue?vue&type=script&lang=ts&"
export * from "./GuideSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./GuideSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports